// extracted by mini-css-extract-plugin
export default {"profilePage":"profile_profilePage__Zi+Fk","profileHead":"profile_profileHead__WmLD7","profileCover":"profile_profileCover__EhCzA"};